import { Heading, Stack } from 'ui-components';
import { StylistCardProvider } from '../StylistCardContext';
import { StylistCard } from '../StylistCard';
import { PageLoading } from '../PageLoading';
import { CompleteStylistFragment, useGetCheckedInStylistsQuery } from 'drycut-graphql';

type Props = {
  slug: string;
};

export function StylistBoard({ slug }: Props): React.ReactElement {
  // Get the the data from the server the first time and then use the cache if present.
  const { data, loading } = useGetCheckedInStylistsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });

  const stylists = data?.checkedInStylists?.nodes || [];

  // Filter stylists so we know all of them are present. We are also filtering out stylists that
  // are checked out (this may sound silly because the request only sends stylists that are checked
  // in, but when a stylist checks out apollo can automatically update the cache which would not
  // remove the stylist from the list of stylists that are checked in.)
  const filteredStylists = stylists.filter(
    (stylist): stylist is CompleteStylistFragment =>
      Boolean(stylist) && stylist?.state !== 'CHECKED_OUT',
  );

  if (loading) return <PageLoading />;

  if (filteredStylists.length === 0)
    return (
      <Heading variant="h3" className="font-aribau text-2xl text-zinc-400">
        Es ist noch kein Mitarbeiter im System eingeloggt.
      </Heading>
    );

  return (
    <Stack direction="row" className="gap-6 items-start justify-center">
      {filteredStylists.map((stylist) => (
        <StylistCardProvider key={stylist.id} stylist={stylist}>
          <StylistCard />
        </StylistCardProvider>
      ))}
    </Stack>
  );
}
